import { waitForAuthorizer } from '@/auth/useAuthorizer'
import { useAuthStore } from '@/auth/useAuthStore'
import { getRedirectToLogin } from '@/router/guards/common/getRedirectToLogin'

import { checkPermissionsV2 } from './checkPermissionsV2'
import { type HermesGuardFn } from './types'

export const checkPermissions: HermesGuardFn = async (to) => {
  const authStore = useAuthStore()

  if (to.meta.isPublic) return
  if (!authStore.user) return getRedirectToLogin(to)

  const authorizer = await waitForAuthorizer()
  if (!authorizer) return authStore.home

  return checkPermissionsV2(to, authStore, authorizer)
}
